import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

const Institution = () => import('./institution/index.vue')
const Contact = () => import('./contact/index.vue')
const VisitPlanning = () => import('./visit-planning/index.vue')
const Visit = () => import('./visit/index.vue')
const PlanningCycle = () => import('./planning-cycle/index.vue')
const Calendar = () => import('./calendar/index.vue')
const Dashboard = () => import('./dashboard/index.vue')
const PlannerItem = () => import('./adm-planner/index.vue')
const VisitEvolution = () => import('./visit-evolution/index.vue')
const InstitutionEvolution = () => import('./institution-evolution/index.vue')

export const CRM_DASHBOARD_PATH = '/crm/dashboard';
export const CRM_CALENDAR_VISIT_PATH = '/crm/calendario';
export const crmRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_DASHBOARD_VIEW
  ])
) {
  crmRoutes.push({
    path: CRM_DASHBOARD_PATH,
    name: 'CRM|Painel de indicadores',
    component: Dashboard,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_VISITS_EVOLUTION
  ])
) {
  crmRoutes.push({
    path: '/crm/visitas/evolucao',
    name: 'CRM|Evolução de Visitas',
    component: VisitEvolution,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_INSTITUTION_EVOLUTION
  ])
) {
  crmRoutes.push({
    path: '/crm/instituicoes/evolucao',
    name: 'CRM|Evolução das Instituições',
    component: InstitutionEvolution,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_INSTITUTION_VIEW
  ])
) {
  crmRoutes.push({
    path: '/crm/instituicoes',
    name: 'CRM|Instituição',
    component: Institution,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_CONTACT_VIEW
  ])
) {
  crmRoutes.push({
    path: '/crm/contatos',
    name: 'CRM|Contato',
    component: Contact,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_VISIT_PLANNING_VIEW,
    PERMISSIONS_KEYS.CRM_VISIT_VIEW,
  ])
) {
  crmRoutes.push({
    path: CRM_CALENDAR_VISIT_PATH,
    name: 'CRM|Calendário de Visita',
    component: Calendar,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}


if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_VISIT_PLANNING_VIEW
  ])
) {
  crmRoutes.push({
    path: '/crm/visitas/agendamentos',
    name: 'CRM|Agendamento de Visita',
    component: VisitPlanning,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_VISIT_VIEW
  ])
) {
  crmRoutes.push({
    path: '/crm/visitas',
    name: 'CRM|Registro de Visita',
    component: Visit,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_PLANNING_CYCLE_VIEW
  ])
) {
  crmRoutes.push({
    path: '/crm/ciclos-planejamento',
    name: 'CRM|Ciclos de Planejamento',
    component: PlanningCycle,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}
if (
  checkUserPermissions([
    PERMISSIONS_KEYS.CRM_PLANNER_ITEM_VIEW
  ])
) {
  crmRoutes.push({
    path: '/crm/agenda/itens',
    name: 'CRM|Agenda - Evento / Atividade',
    component: PlannerItem,
    meta: {
      icon: 'fa-briefcase',
      requiresAuth: true,
    },
  });
}

export const hasCrmVisitPermission = () => {
  return checkUserPermissions([
    PERMISSIONS_KEYS.CRM_VISIT_VIEW,
    PERMISSIONS_KEYS.CRM_VISIT_PLANNING_VIEW
  ]);
};



